import { X } from 'lucide-react'

interface FilterPanelHeaderProps {
  title: string
  subtitle: string
  onClose: () => void
}

export function FilterPanelHeader({ title, subtitle, onClose }: FilterPanelHeaderProps) {
  return (
    <div className="p-6 border-b border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-semibold">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-md transition-colors"
          aria-label="Fechar"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>
      </div>
      <p className="text-sm text-gray-600">{subtitle}</p>
    </div>
  )
}
